module.exports = __webpack_public_path__ + "img/partner2.b624a15b.png";